import React from 'react';

const widthContentOnly = {
  width: '1px',
};

const ColGroup = () => (
  <colgroup>
    <col style={{ width: '175px' }} />
    <col style={widthContentOnly} />
    <col style={widthContentOnly} />
    <col style={widthContentOnly} />
    <col style={{ width: '175px' }} />
    <col style={{ width: '175px' }} />
    <col style={{ width: '150px' }} />
    <col style={{ width: '150px' }} />
    <col style={widthContentOnly} />
    <col style={widthContentOnly} />
    <col style={widthContentOnly} />
    <col style={widthContentOnly} />
    <col style={widthContentOnly} />
    <col style={{ width: '250px' }} />
  </colgroup>
);

export default ColGroup;
